<template>
  <div>
    <b-button
      v-if="!hasValues"
      :disabled="disabled"
      :size="size"
      type="button"
      variant="primary"
      @click="addValue"
    >
      <i class="fa-solid fa-plus"></i> Add ICPC
    </b-button>
    <template v-else v-for="(element, index) in values">
      <b-form-group>
        <b-input-group>
          <b-form-input
            readonly
            :size="size"
            :placeholder="`ICPC #${index + 1}`"
            v-model="element.name"
            @click="showICPCModal(index)"
          />
          <template v-if="!disabled">
            <b-input-group-append>
              <b-button
                v-if="last === index"
                :size="size"
                :disabled="isMax"
                type="button"
                variant="success"
                @click="addValue"
              >
                <i class="fa-solid fa-plus"></i>
              </b-button>
              <b-button
                :size="size"
                type="button"
                variant="danger"
                @click="deleteValue(index)"
              >
                <i class="fa-solid fa-minus"></i>
              </b-button>
            </b-input-group-append>
          </template>
        </b-input-group>
      </b-form-group>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import ICPCModal from '../catalogue/ICPCModal'
import { mapGetters, mapState, mapActions } from "vuex"

export default {
  name: "multiple-icpc-field",
  props: {
    placeholder: {
      type: String,
      default: 'Set Placeholder'
    },
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxInputs: {
      type: Number,
      default: 5
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  data() {
    return {
      selectedIndex: null,
      values: []
    }
  },
  computed: {
    ...mapState('catalogue', {
      icpc: state => state.icpc_codes,
    }),
    isMin() {
      return this.values.length < 2
    },
    isMax() {
      return this.values.length === this.maxInputs
    },
    last() {
      return this.values.length - 1
    },
    hasValues() {
      return this.values.length > 0
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val.length) {
          this.values.length = 0
        }else{
          this.values = this.icpc.filter(obj => val.includes(obj.id))
        }
      }
    }
  },
  methods: {
    ...mapActions('catalogue', ['getCatalogueItem']),
    emitIds() {
      this.$emit('input', this.values.map(obj => obj.id))
    },
    deleteValue(index) {
      this.values.splice(index, 1)
      this.emitIds()
    },
    addValue() {
      this.values.push({})
      const lastIndex = this.values.length - 1
      this.showICPCModal(lastIndex)
    },
    showICPCModal(index) {
        var ComponentClass = Vue.extend(ICPCModal)
        var instance = new ComponentClass({ parent: this })

        instance.$on("hidden", () => {
            instance.$destroy()
        })

        instance.$on("selected", (icpc) => {
            this.values[index] = icpc
            this.emitIds()
        })

        instance.$mount()
    }
  },
  async mounted() {
      await this.getCatalogueItem('icpc_codes')
  }
}
</script>
